import * as React from 'react';
import SearchProvider from './state/SearchProvider';
import SearchApp, { AppProps } from './App';

interface SearchProps extends AppProps {
  endpoint: string;
}

const Search: React.FC<SearchProps> = ({ endpoint, ...params }) => {
  return (
    <SearchProvider endpoint={endpoint} sortOrder={params.sortOrder}>
      <SearchApp {...params} />
    </SearchProvider>
  );
};

export default Search;
